import request from "./request.js";
import axios from "axios";
axios.defaults.withCredentials = true;
axios.defaults.timeout = 360000;
export default {
  // 回到顶部
  goTop() {
    let distance =
      document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
    let step = distance / 0; //每步的距离
    (function jump() {
      if (distance > 0) {
        distance -= step;
        window.scrollTo(0, distance);
        setTimeout(jump, 10);
      }
    })();
  },
  // 订单支付
  getPay(
    self,
    crgtype,
    paytype,
    ordername,
    rmb,
    ordertype,
    orderid,
    extdata,
    callback
  ) {
    /*
    crgtype：0.金币消费1.充值金币 2.现金消费 3.vip特权消费 4.svip特权消费
    paytype-支付平台类型：0.金币1.支付宝 2.微信 3.推广金 4.苹果支付 5.小米支付 6-字节小程序拉起支付
    ordername-订单名称
    rmb-订单金额(金币支付时传入的为金币值)
    ordertype-业务类型：0.默认 1.开通vip 2.真人配音 3.录音转写 4.实时转写 5.真人平台 6.真人平台额外报价子订单
    orderid-订单id
    getRes-支付回调
    */
    let jb = rmb.toFixed(2) * 10;
    // 金币支付时改变传参
    if (crgtype == 0) {
      jb = rmb;
      rmb = "";
    }
    let json = {
      crgtype: crgtype,
      paytype: paytype,
      ordername: ordername,
      jb: jb,
      rmb: rmb,
      orderid: orderid,
      ordertype: ordertype,
      extdata: extdata,
      ish5: 4
    };
    let url = self.$store.state.base_api + self.$store.state.base_url.cashorder;
    request.postHttp(json, url, response => {
      callback(response);
    });
  },
  // 询问前往开通会员
  goToOpenVip(self, text) {
    self.$alert("如需导出，请前往小程序开通", "提示", {
      confirmButtonText: "确定"
    });
  },
  // 判断登录状态
  judgeNotLogin(self) {
    if (!self.$store.state.login_state) {
      self.$store.commit("setShowLogin", true);
      return true;
    } else {
      return false;
    }
  },
  // 退出登录
  exitLogin(self) {
    let url =
      self.$store.state.base_api + self.$store.state.base_url.userlogout;
    request.postHttp({}, url, response => {
      console.log("退出登录", response);
      if (response.rc != "0") {
        alert("退出登录失败");
        return;
      }
      self.$store.commit("setUserinfo", {});
      self.$store.commit("setUserrich", {});
      self.$store.commit("setLoginState", false);
    });
  },
  // 获取用户信息
  getUserInfo(self) {
    let url =
      self.$store.state.base_api + self.$store.state.base_url.qryuserallinfo;
    request.postHttp({}, url, response => {
       console.log("response-login", response);
      // 免费的小程序渠道列表
      const free = ['110771', '210771']
      const qd = localStorage.getItem("qd")
      if (free.indexOf(qd) === -1) {
        if (response.rc == "101") {
          //登录信息异常(清除登陆状态)
          self.$store.commit("setShowLogin", true);
          self.$store.commit("setLoginState", false);
          return;
        } else if (
          response.model.userrich.isvalidsvip !== "1" &&
          response.model.userrich.isvalidvip !== "1"
        ) {
          self.$store.commit("setShowLogin", true);
          self.$store.commit("setLoginState", false);
          self.$message({
            message: "您的会员已到期，请续费使用！",
            type: "warning"
          });
          return;
        } else if (response.rc === "3100") {
          self.$store.commit("setShowLogin", true);
          self.$store.commit("setLoginState", false);
          self.$message({
            message: "您的设备码已过期，请前往小程序重新生成！",
            type: "warning"
          });
          return;
        }
      } else {
        response.model.userrich = '1'
      }
      self.$store.commit("setUserinfo", response.model.userinfo);
      self.$store.commit("setUserrich", response.model.userrich);
      self.$store.commit("setLoginState", true);
      self.$store.commit("setShowLogin", false);
    });
  },
  //下载文件
  downloadDub(ttsurl) {
    window.location.href = ttsurl + "?d=pc";
    // window.open(ttsurl + "?d=pc")
  },
  // 从本地选择文件并转换为oss地址
  getFile(file, callback) {
    // 这个接口不加解密
    let url = 'https://pysq.shipook.com/v2app/peiyin/music/uploadcustombgmusic'
    let data = new FormData();
    data.append("file", file);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      transformRequest: [function (data) {
        return data
      }],
      onUploadProgress: progressEvent => {
        let persent = (progressEvent.loaded / progressEvent.total * 100 | 0)		//上传进度百分比
        console.log(persent)
      },
    }
    axios
      .post(url, data, config)
      .then(response => {
        console.log(response);
        if (response.data.model.ismax == "1") {
          console.log('文件过大')
          callback(response);
          return;
        }
        callback(response);
      })
      .catch(error => {
        console.log(error);
      });
  },
  // 格式化毫秒
  formatDuring(mss) {
    // 天
    var days = parseInt(mss / (1000 * 60 * 60 * 24));
    // 小时
    var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    // 分钟
    var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    // 秒
    var seconds = (mss % (1000 * 60)) / 1000;
    return minutes + ":" + seconds;
  },
  formatFileSize(limit) {
    var size = "";
    if (limit < 0.1 * 1024) {
      //小于0.1KB，则转化成B
      size = limit.toFixed(2) + "B";
    } else if (limit < 0.1 * 1024 * 1024) {
      //小于0.1MB，则转化成KB
      size = (limit / 1024).toFixed(2) + "KB";
    } else if (limit < 0.1 * 1024 * 1024 * 1024) {
      //小于0.1GB，则转化成MB
      size = (limit / (1024 * 1024)).toFixed(2) + "MB";
    } else {
      //其他转化成GB
      size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }

    var sizeStr = size + ""; //转成字符串
    var index = sizeStr.indexOf("."); //获取小数点处的索引
    var dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
    if (dou == "00") {
      //判断后两位是否为00，如果是则删除00
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
    return size;
  },
  // 获取背景音乐bgid
  detection(ary, url) {
    for (let i = 0; i < ary.length; i++) {
      for (let item of ary[i].bgmusicList) {
        if (url == item.bgmusicurl) {
          return item;
        }
      }
    }
  },
  // 查询接口调用次数
  qryApiLimit(self, apiType, callback) {
    console.log(self.$store.state.userrich);
    if (self.$store.state.userrich.isvalidsvip === "1") {
      callback();
      return;
    }
    let url =
      self.$store.state.app_api + self.$store.state.app_url.qryapilimitapp;
    let json = {
      apiType: apiType,
      isVip: self.$store.state.userrich.isvalidvip
    };
    request.postHttp(json, url, response => {
      if (response.rc == 0) {
        var result = response.model;
        var notvipLimit =
          result.config[0] == -1 ? "不限次数" : `限${result.config[0]}次`;
        var isvipLimit =
          result.config[1] == -1 ? "不限次数" : `限${result.config[1]}次`;
        var availableMsg =
          result.available <= 0 ?
            "您的剩余可用次数不足" :
            `您还剩${result.available}次，是否继续？`;
        if (result.available < 0) {
          callback();
          return;
        }
        self
          .$confirm(
            `音量放大功能，普通用户每天${notvipLimit}，vip用户每天${isvipLimit}，svip用户不限次数。${availableMsg}`, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
          )
          .then(() => {
            if (result.available > 0) {
              callback();
            }
          });
      }
    });
  },
  // 更新api使用剩余次数
  uptApiLimit(self, apiType) {
    let url =
      self.$store.state.app_api + self.$store.state.app_url.uptapilimitapp;
    let json = {
      apiType: apiType,
      isVip: self.$store.state.userrich.isvalidvip
    };
    self.$request.postHttp(json, url, response => { });
  }
};



// WEBPACK FOOTER //
// ./src/utils/globalFunction.js